import{openDeepLink}from"../../action-creators/app";import handleLink from"./handleLink";/**
 * Opens a DeepLink.
 * @param {Object} [payload={}] The deep link event payload.
 * @return {Function} A redux thunk.
 */export default function handleDeepLink(){var payload=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return function(dispatch){dispatch(handleLink(payload));dispatch(openDeepLink(payload));};}